



export const setIndicatorData =(indicator_data)=>({
    type:"IND_INIT_DATA",
    indicator_data
});
